import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";


const onMouseEnter = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

const onMouseOut = (event, color, bgColor) => {
  const el = event.target;
  el.style.color = color;
  el.style.backgroundColor = bgColor;
};

export default function innerButton(props) {
  const theme = props.theme;
  const href = props.href;
  const newTab = props.newTab;
  const text = props.text;
  const className = props.className;

  return (
    <div className={className}>
      <Link
        class="main-button"
        to={href}
        target={newTab && "_blank"}
        style={{
          color: theme.body,
          backgroundColor: theme.text,
          border: `solid 1px ${theme.text}`,
        }}
        onMouseEnter={(event) => onMouseEnter(event, theme.text, theme.highlight)}
        onMouseOut={(event) => onMouseOut(event, theme.highlight, theme.text)}
      >
        {text}
      </Link>
    </div>
  );
}
